module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "bottom"
  }, [(_vm.content && _vm.isDefaultView === true) ? _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "personalizedPanel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showVideo()
      }
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      backgroundImage: ("url('" + (_vm.content.thumbImage) + "')"),
      height: _vm.imageHeight + 'px'
    }),
    attrs: {
      "width": "30",
      "desktop": "15",
      "tablet": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "calcHeight",
    attrs: {
      "width": "70",
      "desktop": "85",
      "tablet": "70"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "wrap": "allow",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Personalised for you")]), _vm._v(" "), _c('div', {
    staticClass: "summaryTitle"
  }, [_vm._v(_vm._s(_vm.content.summaryTitle))]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.content.subTitle))])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.content && _vm.isVideoVisible === true) ? _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "continueWatchingPanel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showVideo()
      }
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      backgroundImage: ("url('" + (_vm.course.image_url) + "')"),
      height: _vm.imageHeight + 'px'
    }),
    attrs: {
      "width": "30",
      "desktop": "15",
      "tablet": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "calcHeight",
    attrs: {
      "width": "70",
      "desktop": "85",
      "tablet": "70"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "wrap": "allow",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Continue learning")]), _vm._v(" "), _c('div', {
    staticClass: "summaryTitle"
  }, [_vm._v("Click here once you have finished watching this video")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("Continue to this weeks's module")])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoVisible && (_vm.content.intl_language_video !== '' && _vm.content.intl_language_video !== null)) ? _c('div', [(_vm.activeTab === 'local') ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.local_language_video
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'intl') ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.intl_language_video
    }
  }) : _vm._e()], 1) : _c('div', [(_vm.isVideoVisible && _vm.content) ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.local_language_video
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.content.language_id !== null && _vm.content.intl_language_video !== '' && _vm.isVideoVisible) ? _c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "intl",
      "title": _vm.content.language
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "local",
      "title": _vm.content.local_language
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1d4080","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/PersonalizedPanel/PersonalizationPanel.vue
// module id = 3214
// module chunks = 1